import { styled } from 'styled-components';
import {
  Sheet,
  SheetPortal,
  tk,
  Typography,
  SheetClose,
  SheetContent,
  SheetHeader,
  SheetOverlay,
  SheetTitle,
  SheetContentWrapper,
  type SheetVariant,
} from '@sunwebgroup/ui-components';
import { useIntl } from '@/intl';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { useEffect } from 'react';
import { createPDPClickEvent } from '@/scopes/products/infrastructure/analytics';
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints';
import * as React from 'react';

const Wrapper = styled.div`
  padding-top: ${tk('spacing_lg')};
  padding-bottom: ${tk('spacing_lg')};
  padding-left: ${tk('spacing_md')};
  padding-right: ${tk('spacing_md')};

  ${Typography.modVariant('body-md')};

  @media ${tk('mq_desktop_md')} {
    flex-direction: row;
  }
`;

interface LegalDisclamerProps {
  showModal: boolean;
  closeModal: () => void;
}

export function LegalDisclamer({ showModal, closeModal }: LegalDisclamerProps) {
  const intl = useIntl();
  const { sendEvent } = useAnalytics();
  const { isTablet } = useBreakpoints();
  const sheetWrapperSide = isTablet ? 'right' : ('bottom' as SheetVariant);

  useEffect(() => {
    if (showModal) {
      sendEvent(
        createPDPClickEvent({
          element: 'Modal',
          description: 'Show legal information about the reviews',
          result: 'Modal with legal information opened',
          type: 'Reviews legal information modal',
        })
      );
    }
  }, [sendEvent, showModal]);

  const handleModalClose = () => {
    closeModal();
    sendEvent(
      createPDPClickEvent({
        element: 'Modal',
        description: 'Hide legal information about the reviews',
        result: 'Modal with legal information closed',
        type: 'Reviews legal information modal',
      })
    );
  };

  return (
    <Sheet open={showModal} onOpenChange={handleModalClose}>
      <SheetPortal>
        <SheetOverlay onClick={() => handleModalClose} />
        <SheetContent $side={sheetWrapperSide}>
          <SheetHeader>
            <SheetTitle>{intl.formatMessage({ id: 'reviews_legal_disclaimer_title' })}</SheetTitle>
            <SheetClose>{intl.formatMessage({ id: 'close' })}</SheetClose>
          </SheetHeader>
          <SheetContentWrapper>
            <Wrapper
              dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'reviews_legal_disclaimer_html' }) }}
            />
          </SheetContentWrapper>
        </SheetContent>
      </SheetPortal>
    </Sheet>
  );
}
